"use client";

import Image from "next/image";
import { useAppDispatch } from "@/redux/hook";
import {
  handleModalProduct,
  handleOpenModal,
} from "@/redux/features/utility";
import { useEffect, useState } from "react";
import { Eye } from "lucide-react";

export default function ClothingProductCard({ product, setLoading }: any) {
  const dispatch = useAppDispatch();
  const discountPercent = product.productAttributes?.[0]?.discountPercent || 0;
  const stock = product.productAttributes?.[0]?.stockAmount ?? 0;

  const [isMobile, setIsMobile] = useState(false);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth < 768);
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const handleProductModal = () => {
    dispatch(handleModalProduct({ product }));
    dispatch(handleOpenModal());
  };

    const handleNavigateToDetails = () => {
    setLoading && setLoading(true);
    window.location.href = `/product-details/${product.slug}`;
  };


  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: "100%",
        maxWidth: 230,
        margin: "auto",
        background: "#fff",
        borderRadius: 20,
        overflow: "hidden",
        border: "1px solid #eee",
        boxShadow: hover
          ? "0 18px 40px rgba(0,0,0,0.15)"
          : "0 6px 18px rgba(0,0,0,0.06)",
        transform: hover ? "translateY(-8px)" : "translateY(0)",
        transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
        cursor: "pointer",
        position: "relative",
      }}
    >
      {/* IMAGE */}
      <div
        style={{
          height: isMobile ? 170 : 210,
          background: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Image
          width={200}
          height={200}
          src={product?.images?.[0]?.image ?? "/noimage.png"}
          alt={product?.name}
          style={{
            objectFit: "contain",
            transition: "transform .35s ease",
            transform: hover ? "scale(1.12)" : "scale(1)",
          }}
        />

        {/* SHIMMER EFFECT */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-75%",
            width: "50%",
            height: "100%",
            background:
              "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%)",
            transform: hover ? "translateX(300%)" : "translateX(0)",
            transition: "transform 0.8s ease-in-out",
          }}
        />

        {/* DISCOUNT BADGE */}
        {discountPercent > 0 && (
          <span
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              padding: "4px 9px",
              fontSize: 10,
              fontWeight: 700,
              background: "linear-gradient(135deg,#ff5f5f,#ff3434)",
              color: "#fff",
              borderRadius: 999,
              boxShadow: "0 4px 10px rgba(0,0,0,.15)",
            }}
          >
            -{discountPercent}%
          </span>
        )}
      </div>

      {/* CONTENT */}
      <div
        style={{
          padding: isMobile ? "10px" : "12px",
          display: "flex",
          flexDirection: "column",
          gap: 6,
        }}
      >
        {/* TITLE */}
        <h3
          style={{
            fontSize: isMobile ? 13 : 14,
            fontWeight: 700,
            lineHeight: 1.3,
            color: "#111",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            minHeight: 36,
          }}
        >
          {product?.name}
        </h3>

        {/* PRICE */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 7,
          }}
        >
          <strong
            style={{
              fontSize: isMobile ? 14 : 16,
              fontWeight: 800,
              color: "#000",
            }}
          >
            ৳{product.productAttributes?.[0]?.discountedRetailPrice}
          </strong>

          {discountPercent > 0 && (
            <span
              style={{
                fontSize: 11,
                color: "#aaa",
                textDecoration: "line-through",
              }}
            >
              ৳{product.productAttributes?.[0]?.retailPrice}
            </span>
          )}

          {stock <= 0 && (
            <span
              style={{
                marginLeft: "auto",
                fontSize: 10,
                background: "#fff2f2",
                color: "#ff3c3c",
                padding: "3px 8px",
                borderRadius: 8,
                fontWeight: 700,
              }}
            >
              SOLD
            </span>
          )}
        </div>

        {/* VIEW PRODUCT BUTTON */}
        <button
          onClick={handleNavigateToDetails}
          disabled={stock <= 0}
          style={{
            marginTop: "6px",
            padding: "12px",
            borderRadius: 14,
            background: stock <= 0 ? "#efefef" : "linear-gradient(135deg,#000,#555)",
            color: stock <= 0 ? "#aaa" : "#fff",
            border: "none",
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: ".3px",
            cursor: stock <= 0 ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6,
            transition: "all .3s ease",
            boxShadow: hover
              ? stock > 0
                ? "0 6px 12px rgba(0,0,0,.25)"
                : "none"
              : "0 2px 6px rgba(0,0,0,.1)",
          }}
          onMouseEnter={(e) => {
            if (stock > 0) {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.background = "linear-gradient(135deg,#111,#666)";
            }
          }}
          onMouseLeave={(e) => {
            if (stock > 0) {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.background = "linear-gradient(135deg,#000,#555)";
            }
          }}
        >
          <Eye size={14} />
          View Product
        </button>
      </div>
    </div>
  );
}
